/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompassCurrentSensorSettings } from './CompassCurrentSensorSettings';
import {
    CompassCurrentSensorSettingsFromJSON,
    CompassCurrentSensorSettingsFromJSONTyped,
    CompassCurrentSensorSettingsToJSON,
    CompassCurrentSensorSettingsToJSONTyped,
} from './CompassCurrentSensorSettings';
import type { CompassVoltageSensorSettings } from './CompassVoltageSensorSettings';
import {
    CompassVoltageSensorSettingsFromJSON,
    CompassVoltageSensorSettingsFromJSONTyped,
    CompassVoltageSensorSettingsToJSON,
    CompassVoltageSensorSettingsToJSONTyped,
} from './CompassVoltageSensorSettings';

/**
 * 
 * @export
 * @interface CompassSettingsRequest
 */
export interface CompassSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CompassSettingsRequest
     */
    arc_flash_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompassSettingsRequest
     */
    fall_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompassSettingsRequest
     */
    head_impact_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompassSettingsRequest
     */
    mute_sos_button: boolean;
    /**
     * 
     * @type {CompassCurrentSensorSettings}
     * @memberof CompassSettingsRequest
     */
    compass_current_sensor_settings: CompassCurrentSensorSettings;
    /**
     * 
     * @type {CompassVoltageSensorSettings}
     * @memberof CompassSettingsRequest
     */
    compass_voltage_sensor_settings: CompassVoltageSensorSettings;
    /**
     * 
     * @type {boolean}
     * @memberof CompassSettingsRequest
     */
    adaptive_shared_auto_adapt_enabled?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CompassSettingsRequest
     */
    timestamp: number;
}

/**
 * Check if a given object implements the CompassSettingsRequest interface.
 */
export function instanceOfCompassSettingsRequest(value: object): value is CompassSettingsRequest {
    if (!('arc_flash_detection_on' in value) || value['arc_flash_detection_on'] === undefined) return false;
    if (!('fall_detection_on' in value) || value['fall_detection_on'] === undefined) return false;
    if (!('head_impact_detection_on' in value) || value['head_impact_detection_on'] === undefined) return false;
    if (!('mute_sos_button' in value) || value['mute_sos_button'] === undefined) return false;
    if (!('compass_current_sensor_settings' in value) || value['compass_current_sensor_settings'] === undefined) return false;
    if (!('compass_voltage_sensor_settings' in value) || value['compass_voltage_sensor_settings'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function CompassSettingsRequestFromJSON(json: any): CompassSettingsRequest {
    return CompassSettingsRequestFromJSONTyped(json, false);
}

export function CompassSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'arc_flash_detection_on': json['arc_flash_detection_on'],
        'fall_detection_on': json['fall_detection_on'],
        'head_impact_detection_on': json['head_impact_detection_on'],
        'mute_sos_button': json['mute_sos_button'],
        'compass_current_sensor_settings': CompassCurrentSensorSettingsFromJSON(json['compass_current_sensor_settings']),
        'compass_voltage_sensor_settings': CompassVoltageSensorSettingsFromJSON(json['compass_voltage_sensor_settings']),
        'adaptive_shared_auto_adapt_enabled': json['adaptive_shared_auto_adapt_enabled'] == null ? undefined : json['adaptive_shared_auto_adapt_enabled'],
        'timestamp': json['timestamp'],
    };
}

export function CompassSettingsRequestToJSON(json: any): CompassSettingsRequest {
    return CompassSettingsRequestToJSONTyped(json, false);
}

export function CompassSettingsRequestToJSONTyped(value?: CompassSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arc_flash_detection_on': value['arc_flash_detection_on'],
        'fall_detection_on': value['fall_detection_on'],
        'head_impact_detection_on': value['head_impact_detection_on'],
        'mute_sos_button': value['mute_sos_button'],
        'compass_current_sensor_settings': CompassCurrentSensorSettingsToJSON(value['compass_current_sensor_settings']),
        'compass_voltage_sensor_settings': CompassVoltageSensorSettingsToJSON(value['compass_voltage_sensor_settings']),
        'adaptive_shared_auto_adapt_enabled': value['adaptive_shared_auto_adapt_enabled'],
        'timestamp': value['timestamp'],
    };
}

